<template>
  <div class="report-form">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="110px"
      size="small"
      class="report-form-inner"
    >
      <el-form-item label="员工" prop="applicantUserId">
        <el-select
          v-model="form.applicantUserId"
          placeholder="请选择员工"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in employeeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="当前门店">
        <el-input :value="sourceStoreName" readonly />
      </el-form-item>

      <el-form-item label="离职日期" prop="resignationDate">
        <el-date-picker
          v-model="form.resignationDate"
          type="date"
          placeholder="请选择离职日期"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="离职原因" prop="resignationReason">
        <el-input
          v-model="form.resignationReason"
          type="textarea"
          :rows="3"
          placeholder="请填写离职原因"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="补充说明（选填）"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div class="report-form-footer">
      <el-button size="small" @click="handleReset">重 置</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="handleSubmit">
        {{ submitting ? '提交中...' : '提交离职填报' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { submitPersonnelReport } from '@/api/lqPersonnelReport'

export default {
  name: 'ResignationReportForm',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      submitting: false,
      form: this.createEmptyForm(),
      rules: {
        applicantUserId: [{ required: true, message: '请选择员工', trigger: 'change' }],
        resignationDate: [{ required: true, message: '请选择离职日期', trigger: 'change' }],
        resignationReason: [{ required: true, message: '请填写离职原因', trigger: 'blur' }]
      }
    }
  },
  computed: {
    sourceStoreName() {
      return this.options.sourceMdName || '无'
    },
    employeeOptions() {
      const list = this.options.employees || []
      return list.map(item => ({
        value: item.userId || item.id,
        label: this.formatEmployeeLabel(item)
      })).filter(item => item.value)
    }
  },
  methods: {
    createEmptyForm() {
      return {
        applicantUserId: '',
        resignationDate: '',
        resignationReason: '',
        remark: ''
      }
    },
    formatEmployeeLabel(item) {
      const name = item.realName || item.userName || item.name || '无'
      const mobile = item.mobilePhone || item.mobile || item.mobileMasked || ''
      return mobile ? `${name} · ${this.$maskMobile(mobile)}` : name
    },
    handleReset() {
      this.form = this.createEmptyForm()
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const payload = {
          applicationType: 2,
          applicantUserId: this.form.applicantUserId,
          resignationDate: this.form.resignationDate,
          resignationReason: (this.form.resignationReason || '').trim(),
          remark: (this.form.remark || '').trim() || undefined
        }
        submitPersonnelReport(payload).then(res => {
          const reportNo = (res.data && (res.data.reportNo || res.data.ReportNo)) || ''
          const msg = reportNo ? `提交成功，申请编号：${reportNo}` : (res.msg || '提交成功')
          this.$message.success(msg)
          this.handleReset()
          this.$emit('success', res.data || {})
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-form {
  width: 100%;
}

.report-form-inner {
  max-width: 640px;
}

.report-form-footer {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding-top: 4px;
}
</style>
